const triggerRoiCalculatorOutputFailedEvent = require("./triggerRoiCalculatorOutputFailedEvent");

/**
 * @param roiCalculatorDocument {Document}
 * @return {number}
 */
module.exports = function startRoiCalculatorLoadingTimeout(roiCalculatorDocument) {
    return window.setTimeout(() => {
        triggerRoiCalculatorOutputFailedEvent(roiCalculatorDocument);
    }, 45000);
}